import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../context/AuthContext';
import config from '../config';
import ImageUpload from '../components/ImageUpload';
import '../components/ImageUpload.css';

const AddProduct = () => {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const [formData, setFormData] = useState({
        name: '',
        description: '',
        price: '',
        category: 'chess-sets',
        imageUrl: '',
        stock: '',
        featured: false
    });

    const categories = [
        { value: 'chess-sets', label: 'Chess Sets' },
        { value: 'boards', label: 'Boards' },
        { value: 'pieces', label: 'Pieces' },
        { value: 'clocks', label: 'Clocks' },
        { value: 'books', label: 'Books' },
        { value: 'accessories', label: 'Accessories' }
    ];

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        try {
            const token = localStorage.getItem('token');
            const productData = {
                ...formData,
                price: parseFloat(formData.price),
                stock: parseInt(formData.stock)
            };

            await axios.post(`${config.API_URL}/products`, productData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            setSuccess('Product added successfully!');

            // Reset form
            setFormData({
                name: '',
                description: '',
                price: '',
                category: 'chess-sets',
                imageUrl: '',
                stock: '',
                featured: false
            });

            // Redirect to shop after 2 seconds
            setTimeout(() => navigate('/shop'), 2000);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to add product');
        }
    };

    return (
        <div className="container">
            <div className="form-container">
                <h1>Add New Product</h1>
                {error && <div className="error">{error}</div>}
                {success && <div className="success">{success}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Product Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Description</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            rows="4"
                            required
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Price ($)</label>
                            <input
                                type="number"
                                name="price"
                                value={formData.price}
                                onChange={handleChange}
                                step="0.01"
                                min="0"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Stock Quantity</label>
                            <input
                                type="number"
                                name="stock"
                                value={formData.stock}
                                onChange={handleChange}
                                min="0"
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Category</label>
                        <select
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                            required
                        >
                            {categories.map(cat => (
                                <option key={cat.value} value={cat.value}>
                                    {cat.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <ImageUpload
                        label="Product Image"
                        value={formData.imageUrl}
                        onChange={(url) => setFormData(prev => ({ ...prev, imageUrl: url }))}
                    />

                    <div className="form-group checkbox-group">
                        <label>
                            <input
                                type="checkbox"
                                name="featured"
                                checked={formData.featured}
                                onChange={handleChange}
                            />
                            <span>Featured Product</span>
                        </label>
                    </div>

                    <button type="submit" className="btn">Add Product</button>
                </form>
            </div>
        </div>
    );
};

export default AddProduct;
